/* eslint-disable @typescript-eslint/naming-convention */
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface GroupPermissionStoreState {
  permissionsLoaded: boolean
  homePermission: boolean
  clientManagementPermission: boolean
  clientManagement_LicensedEstablishmentsPermission: boolean
  clientManagement_OrganizationsPermission: boolean
  clientManagement_CorporateAccountsPermission: boolean
  clientManagement_LEConnectUsersPermission: boolean
  patronAccountsPermission: boolean
  rewardsPermission: boolean
  rewards_RewardProgramsPermission: boolean
  rewards_RewardCatalogsPermission: boolean
  rewards_RewardItemsPermission: boolean
  promotionsPermission: boolean
  contestsPermission: boolean
  contests_SweepstakesPermission: boolean
  contests_LocationSweepstakesPermission: boolean
  contests_PassportGamesPermission: boolean
  contests_BadgeRewardsPermission: boolean
  contests_LocationsBadgeRewardsPermission: boolean
  communicationsPermission: boolean
  communications_MessagesPermission: boolean
  communications_BannersPermission: boolean
  jjUpdatesPermission: boolean
  settingsPermission: boolean
  supportToolsPermission: boolean

  setGroupPermissionAccess: (
    homePermission: boolean,
    clientManagementPermission: boolean,
    clientManagement_LicensedEstablishmentsPermission: boolean,
    clientManagement_OrganizationsPermission: boolean,
    clientManagement_CorporateAccountsPermission: boolean,
    clientManagement_LEConnectUsersPermission: boolean,
    patronAccountsPermission: boolean,
    rewardsPermission: boolean,
    rewards_RewardProgramsPermission: boolean,
    rewards_RewardCatalogsPermission: boolean,
    rewards_RewardItemsPermission: boolean,
    promotionsPermission: boolean,
    contestsPermission: boolean,
    contests_SweepstakesPermission: boolean,
    contests_LocationSweepstakesPermission: boolean,
    contests_PassportGamesPermission: boolean,
    contests_BadgeRewardsPermission: boolean,
    contests_LocationsBadgeRewardsPermission: boolean,
    communicationsPermission: boolean,
    communications_MessagesPermission: boolean,
    communications_BannersPermission: boolean,
    jjUpdatesPermission: boolean,
    settingsPermission: boolean,
    supportToolsPermission: boolean
  ) => void
}

export const groupPermissionStore = create<GroupPermissionStoreState>()(
  persist(
    (set) => ({
      permissionsLoaded: false,
      homePermission: false,
      clientManagementPermission: false,
      clientManagement_LicensedEstablishmentsPermission: false,
      clientManagement_OrganizationsPermission: false,
      clientManagement_CorporateAccountsPermission: false,
      clientManagement_LEConnectUsersPermission: false,
      patronAccountsPermission: false,
      rewardsPermission: false,
      rewards_RewardProgramsPermission: false,
      rewards_RewardCatalogsPermission: false,
      rewards_RewardItemsPermission: false,
      promotionsPermission: false,
      contestsPermission: false,
      contests_SweepstakesPermission: false,
      contests_LocationSweepstakesPermission: false,
      contests_PassportGamesPermission: false,
      contests_BadgeRewardsPermission: false,
      contests_LocationsBadgeRewardsPermission: false,
      communicationsPermission: false,
      communications_MessagesPermission: false,
      communications_BannersPermission: false,
      jjUpdatesPermission: false,
      settingsPermission: false,
      supportToolsPermission: false,
      setGroupPermissionAccess: (
        homePermission: boolean,
        clientManagementPermission: boolean,
        clientManagement_LicensedEstablishmentsPermission: boolean,
        clientManagement_OrganizationsPermission: boolean,
        clientManagement_CorporateAccountsPermission: boolean,
        clientManagement_LEConnectUsersPermission: boolean,
        patronAccountsPermission: boolean,
        rewardsPermission: boolean,
        rewards_RewardProgramsPermission: boolean,
        rewards_RewardCatalogsPermission: boolean,
        rewards_RewardItemsPermission: boolean,
        promotionsPermission: boolean,
        contestsPermission: boolean,
        contests_SweepstakesPermission: boolean,
        contests_LocationSweepstakesPermission: boolean,
        contests_PassportGamesPermission: boolean,
        contests_BadgeRewardsPermission: boolean,
        contests_LocationsBadgeRewardsPermission: boolean,
        communicationsPermission: boolean,
        communications_MessagesPermission: boolean,
        communications_BannersPermission: boolean,
        jjUpdatesPermission: boolean,
        settingsPermission: boolean,
        supportToolsPermission: boolean
      ) =>
        set({
          permissionsLoaded: true,
          homePermission,
          clientManagementPermission,
          clientManagement_LicensedEstablishmentsPermission,
          clientManagement_OrganizationsPermission,
          clientManagement_CorporateAccountsPermission,
          clientManagement_LEConnectUsersPermission,
          patronAccountsPermission,
          rewardsPermission,
          rewards_RewardProgramsPermission,
          rewards_RewardCatalogsPermission,
          rewards_RewardItemsPermission,
          promotionsPermission,
          contestsPermission,
          contests_SweepstakesPermission,
          contests_LocationSweepstakesPermission,
          contests_PassportGamesPermission,
          contests_BadgeRewardsPermission,
          contests_LocationsBadgeRewardsPermission,
          communicationsPermission,
          communications_MessagesPermission,
          communications_BannersPermission,
          jjUpdatesPermission,
          settingsPermission,
          supportToolsPermission,
        }),
    }),
    {
      name: 'group-permission-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
